import { httpReducer, reduceReducers } from "../lib/create-action";
import { sendMessageActionName, getMessagesActionName } from "../action_managers/messages";
import isEqual from "lodash/isEqual";
const initialState = {};
const getMessageReducer = httpReducer(getMessagesActionName, initialState, {
  success: (state, action) => {
    if (isEqual(action.payload.resp, state[action.data.threadUUID])) return state;
    return {
      ...state,
      [action.data.threadUUID]: action.payload.resp,
    };
  },
  failure: (state, action) => ({ ...state, error: action.payload.error }),
});

const sendMessageReducer = httpReducer(sendMessageActionName, initialState, {
  started: (state, action) => {
    return {
      ...state,
      [action.body.threadUUID]: state[action.body.threadUUID].concat({
        ...action.body,
        senderUUID: action.data.userUUID,
      }),
    };
  },
  success: (state, action) => ({ ...state }),
  failure: (state, action) => ({ ...state }),
});

export default reduceReducers(getMessageReducer, sendMessageReducer);
